module.exports = __webpack_public_path__ + "img/1F639.ae5e0d5a.svg";